import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProcessInstanceListItem } from '#shared/types/processInstance';
import { ErrorInfo } from '#shared/types/common';
import { FilterParams, Order } from '#web-components/types/table';
import { ROWS_PER_PAGE_OPTIONS } from '#web-components/components/Table';

const ACTION_PREFIX = 'processInstances';

export interface ProcessInstancesState {
  list: Array<ProcessInstanceListItem>;
  count: number;
  filterParams: FilterParams;
}

const initialState: ProcessInstancesState = {
  list: [],
  count: 0,
  filterParams: {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE_OPTIONS[0],
    order: Order.desc,
    orderField: 'startTime',
  },
};

export const getProcessInstancesRequest = createAction<{
  filterParams: FilterParams, isInitialRequest?: boolean
}>(`${ACTION_PREFIX}/getProcessInstancesRequest`);
export const getProcessInstancesError = createAction<ErrorInfo>(`${ACTION_PREFIX}/getProcessInstancesError`);
export const getProcessInstancesCountRequest = createAction(`${ACTION_PREFIX}/getProcessInstancesCountRequest`);
export const getProcessInstancesCountError = createAction<ErrorInfo>(`${ACTION_PREFIX}/getProcessInstancesCountError`);

const ProcessInstancesSlice = createSlice({
  name: ACTION_PREFIX,
  initialState,
  reducers: {
    getProcessInstancesSuccess(state, action: PayloadAction<{
      list: Array<ProcessInstanceListItem>,
      filterParams: FilterParams,
    }>) {
      const { list, filterParams } = action.payload;
      return {
        ...state,
        list,
        filterParams,
      };
    },
    getProcessInstancesClean(state) {
      return {
        ...state,
        count: 0,
        list: [],
        filterParams: initialState.filterParams,
      };
    },
    getProcessInstancesCountSuccess(state: ProcessInstancesState, action: PayloadAction<number>) {
      return {
        ...state,
        count: action.payload,
      };
    },
    getProcessInstancesCountClean(state: ProcessInstancesState) {
      return {
        ...state,
        count: 0,
      };
    },
  },
});

export const {
  getProcessInstancesSuccess,
  getProcessInstancesClean,
  getProcessInstancesCountSuccess,
  getProcessInstancesCountClean,
} = ProcessInstancesSlice.actions;
export default ProcessInstancesSlice.reducer;
